import React from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useFilter } from "../../hooks";
import { sendStaffAppMetaData } from "../../eventTriggers";

export const ProbationHistory = () => {
  const { probations, config } = useSelector((state) => state);
  const [filter, setFilter, Input] = useFilter();
  const dispatch = useDispatch();

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "probation",
        resource,
      },
    });
    sendStaffAppMetaData(
      config.tab_default_meta_data.find(
        (tab) => tab.detail == "probations"
      ).modal
    );
  }

  return (
    <>
      <Input {...{ filter, setFilter }} />
      {probations
        .filter((probation) => (probation.notes ? probation.notes : ''))
        .map((probation) => (
          <div
            key={probation.id}
            onClick={() => handleClick(probation)}
            className="p-4 border-bottom clickable"
          >
            <b>{!!probation.notes ? probation.notes : 'No Notes'}</b>
            <div>
              { probation.starts_at ? moment(probation.starts_at).format("MM/DD/YYYY") : 'n/a' } -&nbsp;
              { probation.ends_at ? moment(probation.ends_at).format("MM/DD/YYYY") : 'Current' }
            </div>
          </div>
        ))}
    </>
  );
};
